var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStacked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 854 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 480,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.13,393.74c0,1.36-.09,2.72-.13,4.08v55.94q426.9,13.37,854,0v-60Q427.18,407.15.13,393.74Z",
    fill: "#ff0089",
    opacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,355.41a5502.2,5502.2,0,0,0,854,0V295.26a5442.9,5442.9,0,0,1-853.87,0c0,.54-.09,1.08-.13,1.63Z",
    fill: "#ff0089",
    opacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M854,226V165.26a2730,2730,0,0,1-854,0V226A2789.71,2789.71,0,0,0,854,226Z",
    fill: "#ff0089",
    opacity: 0.85
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0,49.77a1512.13,1512.13,0,0,0,854,.07V0H809.86A1452.16,1452.16,0,0,1,44.39,0H0Z",
    fill: "#ff0089",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStacked);
export default __webpack_public_path__ + "static/media/Stacked.538377fd4d9d517ada994e01650681fb.svg";
export { ForwardRef as ReactComponent };